import { createLucideIcon } from 'lucide-react';
export const FileIcon = createLucideIcon('file-icon', [
  [
    'path',
    {
      d: 'M14.5 3H5V21H19V7.5L14.5 3Z',
      key: '18re6z',
    },
  ],
  [
    'path',
    {
      d: 'M18.5 7.5H14V3.5',
      key: '11grls',
    },
  ],
  [
    'path',
    {
      d: 'M7 11L15 11',
      key: 'mnbky0',
    },
  ],
  [
    'path',
    {
      d: 'M7 14L15 14',
      key: 'pqvnk8',
    },
  ],
  [
    'path',
    {
      d: 'M7 17L15 17',
      key: '13lt5m',
    },
  ],
]);
